import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "./routes/Landing";
import Ruleta from "./routes/Ruleta";
import Raspadita from "./routes/Raspadita";
import Memoria from "./routes/Memoria";
import AppSetup from "./routes/AppSetup";
import AdminLayout from "./routes/admin/AdminLayout";
import Dashboard from "./routes/admin/Dashboard";
import Productos from "./routes/admin/Productos";
import Ganadores from "./routes/admin/Ganadores";
import Configuracion from "./routes/admin/Configuracion";
import Organizacion from "./routes/admin/Organizacion";
import GlobalSettings from "./routes/admin/GlobalSettings";
import Faqs from "./routes/admin/Faqs";
import { DialogsProvider } from "./hooks/useDialogs";
import { FullscreenButton } from "./components/ui/FullscreenButton";

export default function App() {
  return (
    <DialogsProvider>
      <BrowserRouter>
        <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/ruleta" element={<Ruleta />} />
        <Route path="/raspadita" element={<Raspadita />} />
        <Route path="/memoria" element={<Memoria />} />
        <Route path="/setup" element={<AppSetup />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="productos" element={<Productos />} />
          <Route path="ganadores" element={<Ganadores />} />
          {/* Reorg IA 2026-06: "configuracion" (sucursal) pasó a llamarse
              "pantalla" y "global" (branding) a "shopping", para que el
              nombre del menú, el título y la URL coincidan. Redirects
              desde las URLs viejas para no romper bookmarks ni tours. */}
          <Route path="pantalla" element={<Configuracion />} />
          <Route
            path="configuracion"
            element={<Navigate to="/admin/pantalla" replace />}
          />
          {/* Super admin only */}
          {/* Reorg UX 2026-06: Sucursales + Usuarios se unieron en
              "Organizacion" (pestañas internas). Redirects desde las
              URLs viejas para no romper bookmarks ni tours. */}
          <Route path="organizacion" element={<Organizacion />} />
          <Route
            path="sucursales"
            element={<Navigate to="/admin/organizacion" replace />}
          />
          <Route
            path="usuarios"
            element={<Navigate to="/admin/organizacion" replace />}
          />
          {/* Campañas se movió a una pestaña dentro de Administración
              (Organizacion) — 1 solo propósito, no compensa pestaña aparte.
              Redirect desde la URL vieja para no romper bookmarks. */}
          <Route
            path="campanas"
            element={<Navigate to="/admin/organizacion?tab=campanas" replace />}
          />
          <Route path="shopping" element={<GlobalSettings />} />
          <Route
            path="global"
            element={<Navigate to="/admin/shopping" replace />}
          />
          <Route path="faqs" element={<Faqs />} />
        </Route>
        </Routes>
        {/* Botón fullscreen — visible solo en modo kiosko (no admin
            ni setup). Se monta fuera de las Routes para que persista
            al navegar entre Landing/Ruleta/Raspadita/Memoria. */}
        <FullscreenButton />
      </BrowserRouter>
    </DialogsProvider>
  );
}
